import { render, staticRenderFns } from "./SearchOverall.vue?vue&type=template&id=631b009f&"
import script from "./SearchOverall.vue?vue&type=script&lang=js&"
export * from "./SearchOverall.vue?vue&type=script&lang=js&"
import style0 from "./SearchOverall.vue?vue&type=style&index=0&id=631b009f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports